import { useState } from "react";
import classNames from "classnames";
import { PlusOutlined as Plus24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/PlusOutlined";
import { MinusOutlined as Minus24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/MinusOutlined";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { sanitiseTerms } from "@/utils/product/sanitiseTerms";

import styles from "./TermsAndConditionsAccordion.module.scss";
import cx from "classnames";

type TermsAndConditionsAccordionProps = {
  terms: string;
  isGiftWithPurchaseEnabled?: boolean;
  applyNewDrawerUI?: boolean;
  showSideDrawerVariant?: boolean;
};

const TermsAndConditionsAccordion = ({
  terms,
  isGiftWithPurchaseEnabled = false,
  applyNewDrawerUI = false,
  showSideDrawerVariant = false,
}: TermsAndConditionsAccordionProps) => {
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false);

  const sanitisedTerms = sanitiseTerms(terms);

  return (
    <div className={applyNewDrawerUI ? "" : styles.termsAndConditions}>
      <TertiaryButton
        className={cx(
          isGiftWithPurchaseEnabled
            ? applyNewDrawerUI
              ? styles.newTermsAndConditionsButtonGiftWithPurchaseVariant
              : styles.newTermsAndConditionsButtonGiftWithPurchase
            : styles.termsAndConditionsButton,
          showSideDrawerVariant
            ? styles.termsAndConditionsButton__sideDrawerVariant
            : "",
        )}
        icon={accordionOpen ? Minus24PxOutlinedIcon : Plus24PxOutlinedIcon}
        onClick={() => {
          setAccordionOpen(!accordionOpen);
        }}
        data-testid="special-offers-drawer-terms-accordion-button"
        background={applyNewDrawerUI ? "tonal" : "filled"}
        labelText="Terms and conditions apply"
      />
      {accordionOpen && (
        <div
          data-testid="special-offers-drawer-terms-accordion-content"
          className={classNames(styles.accordion)}
          dangerouslySetInnerHTML={{
            __html: sanitisedTerms,
          }}
        ></div>
      )}
    </div>
  );
};

export default TermsAndConditionsAccordion;
